import React, { Fragment, useState } from "react"
import { NormalEvent, SessionnedEvent } from "./Event/Event"
import { useGetEventsByExperienceName } from "../../Hooks"
import { RouteComponentProps } from "@reach/router"
import { Spinner, Modal } from "../../components"
import styles from "./Events.scss"

function renderModal(toggled: boolean, link: string, closeModal: () => void) {
  return toggled && <Modal link={link} closeModal={closeModal} />
}

function openModalWithToggled(setToggled, setLink) {
  return (link) => {
    setLink(link)
    setToggled(true)
  }
}

function closeModalWithToggled(setToggled) {
  return () => {
    setToggled(false)
  }
}

const createSessionnedEvent = (events: EventsInfo[], sessions: Sessions[]) => {
  const sessionedEvents = []
  sessions[0].dates.map((date, j) => {
    const matchedEvent = events.find((event) => event.start === date)

    if (matchedEvent) {
      const { link, participants, quotas } = matchedEvent
      const dateInfo = sessions.map(({ dates, duration }) => ({
        date: dates[j],
        duration,
      }))
      sessionedEvents.push({
        link,
        dateInfo,
        participants,
        quotas,
      })
    }
  })

  return sessionedEvents
}

const renderEvents = (
  isSingleSessioned: boolean,
  events: EventInfo,
  sessions: Session[],
  selectedEventIndex: number,
  setSelectedEventIndex: (index: number) => void
) => {
  if (events.length === 0) {
    return "Pas de dates disponibles pour cette expérience"
  }
  return isSingleSessioned
    ? events.map((event, i) => (
        <NormalEvent
          index={i}
          key={event.title}
          event={event}
          duration={sessions[0].duration}
          selectedEventIndex={selectedEventIndex}
          setSelectedEventIndex={setSelectedEventIndex}
        />
      ))
    : createSessionnedEvent(events, sessions).map((sessionedEvent, i) => (
        <SessionnedEvent
          index={i}
          key={sessionedEvent.title}
          {...sessionedEvent}
          selectedEventIndex={selectedEventIndex}
          setSelectedEventIndex={setSelectedEventIndex}
        />
      ))
}

const EventsPage = ({ location }: RouteComponentProps) => {
  const { sessions, name } = location.state
  const [selectedEventIndex, setSelectedEventIndex] = useState<number>(0)
  const [loading, setLoading] = useState<boolean>(false)
  const [link, setLink] = useState<boolean>(false)
  const [toggled, setToggled] = useState<boolean>(false)
  const events = useGetEventsByExperienceName(name, setLoading)
  const closeModal = closeModalWithToggled(setToggled)
  const openModal = openModalWithToggled(setToggled, setLink)

  function handleButtonClick() {
    openModal(events[selectedEventIndex].link)
  }

  return loading ? (
    <Spinner />
  ) : (
    <Fragment>
      {renderModal(toggled, link, closeModal)}
      <div className={styles.container}>
        <p>Selectionnez une date :</p>
        {renderEvents(
          sessions.length === 1,
          events,
          sessions,
          selectedEventIndex,
          setSelectedEventIndex
        )}
        <button onClick={handleButtonClick}>Suivant</button>
      </div>
    </Fragment>
  )
}

export default EventsPage
